import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import general components
import BaseTabs from "../../common/base-tabs/base-tabs";
import MobileHeader from "../../common/mobile-header/mobile-header";

//import view components
import HotelInformation from "./hotel-information";
import HotelRooms from "./hotel-rooms";

function HotelDetails() {
    //general variables
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation();

    //sessionStorage variables
    const {isItinerary} = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const selectedHotel = JSON.parse(sessionStorage.getItem("selectedHotel"));

    //handle tab change
    const [activeTab, setActiveTab] = useState({ reserveRoom: true, aboutHotel: false });
    const handleTabChange = type => {
        setActiveTab({ [type]: true });
    };

    //list of tabs
    const tabList = [
        { type: "reserveRoom", title: t("reserveRoom"), activeTab: activeTab?.reserveRoom },
        { type: "aboutHotel", title: t("aboutHotel"), activeTab: activeTab?.aboutHotel },
    ];

    //handle navigation back
    const handleGoBack = () => {
        const paramsToDelete = ["hotelId", "action", "tag"];
        paramsToDelete.forEach(param => searchParams.delete(param));
        setSearchParams(searchParams, { replace: true });
    };

    return (
        <Grid container item xs={12} mb={5}>
            <MobileHeader
                title={(selectedHotel?.type ?? t("hotel")) + " " + selectedHotel?.name}
                justifyContent="center"
                isButton={false}
                handleClick={handleGoBack}
            />
            <BaseTabs handleTabChange={handleTabChange} list={tabList} style={{ top: isItinerary ? "6rem" : "3rem" }} />
            {activeTab?.aboutHotel ? <HotelInformation /> : activeTab?.reserveRoom ? <HotelRooms /> : null}
        </Grid>
    );
}

export default HotelDetails;
